import React from 'react';
import PaginatedTable from '../../commonComponents/util/PaginatedTable';
import CampaignListsTableRow from './CampaignListsTableRow';

export default class CampaignListsTable extends React.Component {

    getTableRow(campaignList) {
        return <CampaignListsTableRow key={campaignList.campaignListId} campaignList={campaignList} />;
    }

    render() {
        return <PaginatedTable
            name="campaign lists"
            page={this.props.page}
            totalCount={this.props.data.totalCount}
            resultsView={this.props.resultsView}
            sort={this.props.sort}
            loading={this.props.loading}
            success={this.props.success}
            renderRow={this.getTableRow}
            columns={[
                { id: 'name', title: 'Name', sortable: true },
                { id: 'city', title: 'Location', sortable: true },
                { id: 'count', title: 'People in list', sortable: true },
                { id: 'fund', title: 'Fund', sortable: true }]}
            records={this.props.data.records || []}
            sortData={this.props.updateTable}
            changeDataView={this.props.updateTable}
            loadData={this.props.getCampaignLists}
            noReload={true} />
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignLists/CampaignListsTable.jsx